module.exports = __webpack_public_path__ + "images/category_lp/art_work/point3_ca995ca589d9abfa41004cd98161b9f8.png";